 export default {
    errors: {
        validation: {
            events: {
                start_following_start:
                    "Start marker ({{start_marker}}) at line {{line}} is opened twice",
                end_following_end:
                    "End marker ({{end_marker}}) at line {{line}} is closed twice",
                start_without_end:
                    "Start marker ({{start_marker}}) at line {{line}} is left opened at end of file",
                end_without_start:
                    "End marker ({{end_marker}}) at line {{line}} is not preceeded by start marker ({{start_marker}})",
                duplicate_markers:
                    "Duplicate marker's name caused by {{event}}"
            },
            general: {
                absent_column:
                	"The column {{column}} is absent from the file",
                header_error:
                	"Unable to read file header",
                sampling_rate:
                	"Unable to read sampling rate",
                error_reading_line:
                	"Error while reading line nbr {{lineNbr}}"
            }
        },
        parsing: {
            unknown: "Unkown error while parsing {{software}}",
            generic: "Error while parsing line {{line}} in {{software}}",
            marker: "Marker {{markerName}} is missing",
            duplicate: "Duplicate timestamp: {{timestamp}}",
            camera_filename: "Problem with camera file: {{fileName}}",
            log_filename: "Problem with log file: {{fileName}}",
            photo_filename: "{{fileName}} incorrect photo names",
            skipped_file: "File cannot be processed: {{fileName}}",
            duplicate_photo_id: "Duplicate photo id ({{photo_id}}) in file: {{fileName}}", 
            missing_photo_id: "{{photo_id}} missing photo ids in {{fileName}}", 
            empty_results: "No data was found when parsing {{signal_type_name}}",
            skipped_corrupted_lines: "{{lines}} corrupted lines were skipped in the {{software}} file",
            ntp: "Problem communicating with NTP server"
        },
        synchro: {
            no_associated_pulses: "No pulse found {{signal_type_name}}",
            no_synch_data: "There is no synchronisation anchor (e.g. syncbox) associated with the {{signal_type_name}} signal",
            synch_freq_mismatch: "Not all files have the same sync frequency",
            synch_freq_unknown: "Unable to calculate pulse frequency {{software}}",
            synch_error_rate: "Synchronisation error too high in {{software}} file: {{error}}ms",
            anchor_freq_mismatch: "{{signal}} doesn't have the same sync frequency as {{anchor}}",
            generic_error: "Unable to perform {{software}} synchronisation",
            no_valid_pulse: "All pulses in {{software}} were invalid. Maybe a time precision error.",
            wrong_anchor: "{{anchor}} cannot be used to synchronise {{software}}",
            unfit_anchor: "{{signal}} cannot be use as signal reference (anchor) for synchronisation",
            invalid_ntp_time: "Invalid NTP time in ObserverXT",
            targed_anchor_missing: "{{signal}} data has to be synchronised after {{anchor}}",
            empty_anchor: "Anchor signal {{anchor}} has no pulse",
            sync_accuracy: "{{software}} sync accuracy is (+-) {{accuracy}} ms",
            clap_number: "There is {{pulses}} pulses in {{software}} instead of the expected 8",
            pulse_number:  "Not enough {{anchor}} pulse to sync with {{signal}}",
            erroneous_pulses:  "There are erroneous pulses in {{software1}} or {{software2}}"
        },
        transformation: {
            correct_completion: "Transformation {{transformation_name}} has completed with success",
            incorrect_completion: "Transformation {{transformation_name}} has failed",
            no_event: "No event data to compute {{transformation_name}}",
            no_aoi: "No AOI data to compute {{transformation_name}}"
        },
        generic: {
            system: "System error"
        }
    },
    users: {
        title: "USERS",
        add: "Add User",
        create_new_user: "Create New User",
        general_informations: "User General Informations",
        cancel: "Cancel",
        add_user: "Add User",
        user_name: "User Name",
        user_jobtitle: "User Job Title",
        user_phone: "User Phone Number",
        user_email: "User Email",
        login_informations: "Login Informations",
        login_username: "Login Username",
        login_password: "Login Password",
        admin_permissions: "Admin Permissions",
        remove_user: "REMOVE USER",
        save: "Save",
        edit_user: "Edit User",
        alert_text1: "This will delete ",
        alert_text2: " from the database. Please confirm to remove user.",
        contact_information: "Contact Informations",
        error_valid_name: "Please insert a valid name",
        error_valid_email: "Please insert a valid email address",
        error_valid_phone: "Please Insert a valid phone number",
        error_valid_jobtitle: "Please insert a valid job title",
        error_valid_username: "Please insert a valid username",
        error_valid_password: "Please insert a valid password"
    },
    lab: {
        equipment: "Equipment",
        booking: "Bookings",
        go_to_calendar: "Go to Calendar",
        cancel: "Cancel",
        create: "Create",
        collapse: "Collapse",
        expand: "Expand",
        add_location: "Add Location",
        add_new_building: "Add New Building",
        add_building: "Add Building",
        name: "Name",
        address: "Address",
        no_location: "No Location",
        delete_location: "Delete Location",
        identifier: "Identifier"
    },
    projects: {
        title: "Projects",
        add: "Add project",
        cancel: "Cancel",
        create: "Create",
        create_new_project: "Create New Project",
        general_information: "General Information",
        project_name: "Project Name",
        project_description: "Project Description"
    },
    collapse: "Collapse",
    expand: "Expand",
    data: {
        reference_equipment_title: "REFERENCE EQUIPMENT",
        multifile_equipment_title: "MULTI-FILE EQUIPMENT",
        reference_equipment_text:
            "This is a reference equipment. You need to upload, validate and parse its files before validating and parsing any other files for this participation!",
        multifile_equipment_text:
            "This equipment requires multiple files. Make sure to upload, validate and parse the synchronization file first before validating and parsing all other files for this equipment!",
        batch_process: "Batch Process",
        download_batch_process_data: "Download Project Data",
        data_management: "Data Management",
        show_overview: "Show Overview",
        configuration: "Configuration",
        an_invalid: "An invalid",
        a_valid: "A valid",
        file_was_uploaded: " file was uploaded",
        replace: "Replace",
        upload: "Upload",
        validate: "Validate",
        parse: "Parse",
        configure_default_software_version: "Configure Default Software Versions",
        cancel: "Cancel",
        proceed: "Proceed",
        uses_software: " uses software",
        version: " version: ",
        change: "Change",
        batch_processing: "Batch Processing",
        ready_for_validation: "Ready for Validation",
        ready_for_parsing: "Ready for Parsing",
        validate_all: "Validate All",
        parse_all: "Parse All",
        download: "Download",
        file_mapping: "File Mapping",
        global_files: "Global Files",
        files_per_participation: "Files per Participation",
        participations: "Participations",
        sessions: "Sessions",
        all: "All",
        recorded_in: "Recorded in ",
        has: "Has ",
        participations_lowcase: " participations",
        loading: "Loading...",
        fetching_data: "Fetching data...",
        name: "Name",
        size: "Size",
        size_bytes_display: "{{size}} bytes",
        size_kilobytes_display: "{{size}} KB",
        date_modified: "Date modified",
        select_directory_prompt: "select a directory",
        empty_directory_message: "This directory is empty."
    },
    results: {
        menu: {
            files: "Files",
            visualisation: "Layer",
            analytics: "Analytics",
            parameters: "Parameters",
            save_images: "Save images",
            gaze: "Gaze",
            cognitive_load: "Cognitive load",
            emotion: "Emotion",
            point_cloud: "Point cloud",
            title: "Layers & Groups",
            tools: "Stimuli",
            sea_level: "Sea level",
            align_to_grid: "Align to grid",
            link_stimuli: "Link stimuli",
            unlink_stimuli: "Unlink stimuli",
            layer_settings: "Settings",
            open_stimulus: "Open Stimulus",
            settings: {
                screen: "Screen",
                height: "Height (cm)",
                width: "Width (cm)",
                resolutionX: "Resolution X (px)",
                resolutionY: "Resolution Y (px)",
                span: "Span (deg)",
                acceleration: "Acceleration",
                eyeScreenDistance: "Eye/Screen Distance",
                settings: "Settings"
            }
        },
        layers: {
            title: "Layers",
            add: "Add layer",
            delete: "Delete",
            order_up: "Order up",
            order_down: "Order down",
            name: "Layer Name"
        },
        labels: {
            title: "Labels",
            add: "Add label"
        },
        groups: {
            title: "Groups",
            add: "Add Group",
            edit: "Edit Groups",
            name: "Group Name",
            delete: "Delete Group",
            close: "Close",
            group_name: "Group Name"
        },
        participations: {
            title: "Participations"
        }
    },
    template: {
        configuration: {
            general_information: "General Information",
            session_information: "Session Information",
            project_name: "Project Name",
            project_description: "Project Description",
            participants_per_session: "Participants per Session",
            participants_per_team: "Participants in {{team}}",
            teams_per_session: "Teams per Session",
            sessions_in_project: "Sessions in Project",
            assignment_necessary:
                "There are more than one participants and teams in this project. Assign participations to teams.",
            has_team: "Has Team",
            save: "SAVE"
        },
        booking: {
            booking: "Booking",
            project_duration: "Project Duration",
            start_date: "Start Date",
            end_date: "End Date",
            save: "Save",
            booked_locations: "Booked Locations",
            available_locations: "Available Locations",
            cross_booked: "Cross-Booked",
            booked: "Booked",
            available: "Available",
            not_available: "Not Available",
            select: "Select",
            no_room_available: "No Room Available at this Location",
            unbook_room: "Unbook Room",
            unbook_rooms: "Unbook Rooms",
            book_room: "Book Room",
            book_rooms: "Book Rooms"
        },
        equipment: {
            equipment_list: "Equipment List",
            equipment_assignment: "Equipment Assignment",
            select_type: "Select Equipment Type",
            replace_equipment: "Replace Equipment",
            delete_equipment: "Delete Equipment",
            add_equipment: "Add Equipment",
            flagged_as_broken: "Flagged as Broken",
            marked_as_resolved: "Mark as Resolved",
            replace: "Replace",
            is_global: "Is Global",
            select_signal_type: "Select one or many Signal Type(s):",
            select_feature_type: "Select one or many Feature Type(s):",
            select_hardware: "Select Hardware:",
            select_software: "Select a Software:",
            select_version: "Select Software Version:",
            no_signal_type:
                "There are no Signal Types associated with this Equipment Type",
            equipment_used_by_more_than_one_participant:
                "Is this equipment used by more than one participant?",
            select_device: "Select a Device",
            add: "Add",
            cancel: "Cancel",
            signal_type: "Signal Type(s)",
            hardware: "Hardware",
            instance: "Instance",
            driver: "Driver",
            scope: "Scope",
            global: "Global",
            single_participant: "Single Participant",
            there_are_broken_items: "There are broken equipment items that are ",
            not: "not ",
            shown: "shown   ",
            hide: "HIDE",
            show: "SHOW",
            serial_nb: "Serial Nb. ",
            available: "Available",
            unavailable: "Unvailable",
            booked_until: " (Booked until ",
            not_found: "Not Found",
            add_new_equipment: "Add new equipment",
            global_info:
                "Global equipment is used by all participants in a session - like a SynchBox or a video camera that records the entire scene. If unsure, keep the default value."
        },
        questionnaire: {
            questionnaire: "Questionnaire",
            question: "Question",
            name: "Name",
            add_questionnaire: "Add questionnaire",
            add_question: "Add question",
            cancel: "Cancel",
            create: "Create"
        },
        rules: {
            conditions_rules: "Conditions/Rules",
            all: "All",
            remove_rule: "Remove_rule(s)",
            create_rule: "Create Rule",
            assign: "Assign",
            select_event_source: "Select Event Source",
            rule_type: "Rule Type",
            results: "Results",
            filter_rules: "Filter Rules",
            minimum_occurrence: "Minimum Occurrence",
            maximum_occurrence: "Maximum Occurrence",
            select_order_type: "Select Order Type",
            select_event_target: "Select Event Target",
            filter: "Filter",
            confirm_delete_condition: "Are you sure you want to delete "
        },
        stimuli: {
            add_new_stimuli: "Add New Stimulus",
            import_stimuli: "Import Stimulus",
            name: "Stimuli name",
            type: "Stimuli type",
            source: "Source",
            setups: "Setups",
            start_marker: "Start Marker",
            stop_marker: "Stop Marker",
            actions: "Actions",
            width: "Width",
            height: "Height"
        },
        events: {
            edit_event: "Edit event",
            add_event: "Add event",
            close: "Close",
            save: "Save",
            name: "Name",
            description: "Description",
            type: "Type",
            pointevent: "Pointevent",
            interval: "Interval",
            override_markers_names: "Override marker names",
            start_marker: "Start marker",
            end_marker: "End marker",
            stimulus: "Stimulus",
            edit: "Edit",
            add: "Add",
            create: "Create",
            delete: "Delete",
            select_event_source: "Select Event Source",
            add_rule: "Add Rule",
            occurrence: " Occurrence",
            Delete_rule: "Delete Rule(s)",
            existence_rule: "Existence rule",
            order_rule: "Order rule",
            overlap_rule: "Overlap rule",
            event: "Event [",
            no_overlap_allowed_with_event: "NO OVERLAP ALLOWED with Event [",
            stimulus_name: "Stimulus name",
            stimulus_description: "Stimulus description",
            select_stimulus_type: "Select stimulus type",
            events: "Events",
            add_events: "Add Events",
            single: "single",
            list: "list",
            add_condition: "Add Condition",
            delete_current: "Delete Current",
            show_pool: "Show Pool",
            confirm_delete_condition: "Are you sure you want to delete ",
            cancel: "Cancel",
            pool_events: "Event Pool"
        }
    },
    sessions: {
        copy: "Copy Session",
        add: "Add Session",
        update: "Update",
        delete: "Delete Session",
        repeat: "Repeat Day",
        information: "Session Information",
        start: "Start Session",
        continue: "Continue Session",
        review: "Review Session",
        date: "Date: ",
        start_time: "Start Time: ",
        end_time: "End Time: ",
        participations: "Participations",
        add_participant: "Add Participant",
        teams: "Teams",
        add_team: "Add Team",
        no_show: "No Show",
        no_team_in_session: "No Teams in this Session",
        release_to_assign: "Release to assign",
        drag_participant_here: "Drag a Participant Here",
        cancel: "Cancel",
        duplicate: "Duplicate",
        add_session: "Add Session",
        update_session: "Update Session",
        copy_session: "Copy Session",
        session_name_unused: "Session Name (unused)",
        session_date: "Session Date",
        session_start_time: "Session Start Time",
        session_end_time: "Session End Time",
        pretest: "Pretest",
        number_of_repeat: "Number of Repeat",
        break: "Break (minutes)",
        duplicate_sessions: "Duplicated Sessions",
        new_date: "New Date",
        update_participant: "Update",
        assign: "Assign",
        session_completed: "Session Completed",
        select_condition_for: "Select Condition for ",
        equipment: "Equipment ",
        flagged_as_broken: " Flagged as Broken",
        flag_as_broken: "Flag as Broken",
        temperature: "Temperature",
        room_temperature: "Room Temperature (°C)",
        humidity: "Humidity",
        room_humidity: "Room Humidity (%)",
        save: "Save",
        notes_on: "Notes on ",
        participant_info: "Participant Information",
        name: "Name",
        age: "Age",
        sex: "Sex (F/M/O)",
        validate_participant_details: "Please validate the participants' details",
        validate_equipment_used: "S'il vous plaît validez l'équipement utilisé",
        room_info: "Room Information",
        participation_notes: "Participation Notes",
        equipment_notes: "Equipment Notes",
        select_condition: "Select Condition",
        please_assign_participant_information:
            "Please assign participant information"
    },
    participants: {
        backToParticipants: "Back To Participants",
        participant_informations: "Participant Informations",
        general_informations: "General Informations",
        demographics_informations: "Demographics Informations",
        panel_informations: "Panel Informations",
        user_id: "User ID",
        edit_participant: "Edit Participant",
        remove_participant: "Remove Participant",
        notes: "Notes",
        add_notes: "Add Notes",
        not_panel_participant: "Not a Panel participant",
        name: "Name",
        email: "Email",
        phone: "Phone Number",
        manage: "Manage",
        birthyear: "Birth Year",
        language: "Language",
        sex: "Sex",
        view_details: "View Details",
        cancel: "Cancel",
        submit: "Submit",
        all_participants: "All Participants",
        search_results: "Search Results",
        add_participant: "Add Participant",
        add_new_participant: "Add New Participant",
        error_valid_name: "Please insert a valid name",
        error_valid_email: "Please insert a valid email address",
        error_valid_phone: "Insert a valid phone number",
        error_valid_birthyear: "Insert a valid birth year",
        error_valid_language: "Select a language",
        error_valid_sex: "Select a sex",
        other: "Other",
        man: "Man",
        woman: "Woman",
        search_participant: "Search Participant",
        delete_participant: "Delete Participant",
        confirm_delete_1: "Please confirm that you want to delete ",
        confirm_delete_2: " from the database."
    },
    shared: {
        global_equipment: "Global Equipement",
        assign_equipment_to_participation:
            "Please assign equipments to participants",
        release_to_assign: "Release to assign",
        drag_participant_here: "Drag a Participant Here",
        drag_equipment_here: "Drag Equipment Here",
        select: "Select  ",
        filter: "Filter",
        drop_files: "Drop Files",
        size: " (Size: ",
        drop_files_or_click_to_open_files_browser:
            "Drop File or click to open File Browser",
        emotions: {
            angry: "Angry"
        }
    },
    steps: {
        template: {
            configuration: "Configuration",
            booking: "Booking",
            equipment: "Equipment",
            questionnaire: "Questionnaire",
            events: "Events",
            rules: "Rules",
            stimuli: "Stimuli"
        },
        sessions: {
            general: "General",
            participant_data: "Participant Data",
            equipment: "Equipment",
            conditions: "Conditions",
            notes: "Notes"
        }
    },
    transformations:{
        apply:"Apply",
        applyForAll:"Apply for All",
        applyForSelected:"Apply for selected",
        transformationListTitle: "TRANSFORMATIONS LIST"

    },
    menu: {
        overview: "OVERVIEW",
        template: "TEMPLATE",
        documents: "DOCUMENTS",
        sessions: "SESSIONS",
        data: "DATA",
        results: "RESULTS",
        analysis: "ANALYSIS"
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en.js